import { Accordion, Group, Stack, Text } from '@mantine/core'
import type { AttachmentResponse, VisitWithRelations } from '@markku/types'
import { IconCheck, IconPhoto } from '@tabler/icons-react'

import { PhotoGallery } from '@markku/components'

interface TaskAccordionItemProps {
  task: NonNullable<VisitWithRelations['visitTasks']>[number]
  taskAttachments: AttachmentResponse[]
  index: number
}

export function TaskAccordionItem({
  task,
  taskAttachments,
  index,
}: TaskAccordionItemProps) {
  const taskName =
    task.taskName || task.maintenanceTask?.name || `Toimenpide ${index + 1}`
  const taskDescription =
    task.taskDescription || task.maintenanceTask?.description

  const beforePhotos = taskAttachments.filter(
    (p) => p.metadata?.type === 'before',
  )
  const afterPhotos = taskAttachments.filter(
    (p) => p.metadata?.type === 'after',
  )

  return (
    <Accordion.Item key={task.id} value={`task-${task.id}`}>
      <Accordion.Control>
        <Group align="flex-start" wrap="nowrap">
          <IconCheck
            size={20}
            color="var(--mantine-color-green-6)"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Stack gap={4} style={{ flex: 1 }}>
            <Text fw={500}>{taskName}</Text>
            <Group gap="sm">
              {taskAttachments.length > 0 && (
                <Group gap={4}>
                  <IconPhoto size={14} color="var(--mantine-color-gray-6)" />
                  <Text size="xs" c="dimmed">
                    {taskAttachments.length} kuvaa
                  </Text>
                </Group>
              )}
            </Group>
          </Stack>
        </Group>
      </Accordion.Control>

      <Accordion.Panel>
        <Stack gap="md">
          {taskDescription && (
            <Text size="sm" c="dimmed">
              {taskDescription}
            </Text>
          )}

          {task.notes && (
            <>
              <Text size="sm" fw={500}>
                Markun huomiot
              </Text>
              <Text size="sm" c="dimmed">
                {task.notes}
              </Text>
            </>
          )}

          {taskAttachments.length > 0 && (
            <Stack gap="md">
              <PhotoGallery photos={beforePhotos} label="Ennen" />
              <PhotoGallery photos={afterPhotos} label="Jälkeen" />
            </Stack>
          )}
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  )
}
